import React from "react";
import { Row, Col,Image } from "antd";

export default function MenuTemplate({ data,formFieldsdata,discountData,menuItems }) {
  return (
    <div style={{ padding: 20 }}>
      <Row>
        <Col xs={24} lg={12} className="template-heading">
          Menu Page
        </Col>
      </Row>
      <Row
        className="items-center"
        style={{ backgroundColor: "#F4F1F1", padding: 36, marginTop: 40 }}
      >
        <Col xs={24} lg={12} style={{ padding: 20 }}>
          <div style={{ fontSize: 14, opacity: 0.6 }} className="text-left">
          {formFieldsdata?.menu_discount_heading}
          </div>
          <div className="template-heading text-left mt-2">{discountData.find(item=>item.id ==formFieldsdata?.menu_discount_id)?.code}</div>
        </Col>
        <Col xs={24} lg={12} className="items-center justify-center">
          <div
            className="d-flex items-center justify-center"
            style={{ backgroundColor: "#C4C4C4", width: 216, height: 167 }}
          >
                  <Image width={200} src={formFieldsdata?.menu_discount_image_url} />
          </div>
        </Col>
      </Row>
      <Row style={{ backgroundColor: "#F4F1F1", padding: 36, marginTop: 40 }}>
        <Col span={24}>
          <div className="template-heading text-left">Menu Items</div>
          
          <Row className="d-flex justify-space-between mt-2">
            {menuItems?.map((item) => (
              <Col
                key={item}
                style={{
                  width: 180,
                  height: 220,
                  border: " 1px solid #C4C4C4",
                  borderRadius: 2,
                }}
              >
                <div
                  className="d-flex items-center justify-center"
                  style={{
                    width: "100%",
                    height: "40%",
                    background: "#C4C4C4",
                  }}
                >
                 <Image width={150} height={85} src={item.photo_url}/>
                </div>
                <div className="mt-1 text-left" style={{ paddingLeft: 18 }}>
                  <div>{item.name ?? 'Item name'}</div>
                  <div style={{ fontSize: 12, opacity: 0.6 }}>
                  {item.description ?? 'Item Description'}
                  </div>
                </div>
                <div
                  style={{ paddingLeft: 18, position: "absolute", bottom: 10 }}
                >
                  $ {item.price}
                </div>
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </div>
  );
}
